import { Group, Image, Stack,Text } from '@ekhodealer/ekho-common/rev';

import placeholderImg from '@common/components/images/placeholder.png';

import './DetailedInfoLineItem.scss';

interface DetailedInfoLineItemProps {
	/** The URL for the image */
	imageUrl?: string;
	/** Whether to show a placeholder image when imageUrl is not provided. Defaults to false */
	showPlaceholderImage?: boolean;
	/** The primary label displayed in the stack */
	primaryLabel: string;
	/** The secondary label displayed in the stack */
	secondaryLabel?: string;
	/** The tertiary label displayed in the stack (third line) */
	tertiaryLabel?: string;
	/** The accessory displayed on the right side */
	rightAccessory?: React.ReactNode;
}

/**
 * DetailedInfoLineItem component that displays an image, stacked labels,
 * and a right-aligned accessory
 */
export const DetailedInfoLineItem = ({
	imageUrl,
	showPlaceholderImage = false,
	primaryLabel,
	secondaryLabel,
	tertiaryLabel,
	rightAccessory,
}: DetailedInfoLineItemProps) => {
	return (
		<Group
			itemsAlignX='space-between'
			itemsSpacing='12'
			itemsAlignY='center'
			padding={{ x: '12' }}
			noWrap>
			<Group.Item>
				{imageUrl ? (
					<Image
						src={imageUrl}
						alt={primaryLabel}
						className='detailed-info-line-item__image'
					/>
				) : showPlaceholderImage ? (
					<Image
						src={placeholderImg}
						alt='Placeholder'
						className='detailed-info-line-item__image'
					/>
				) : null}
			</Group.Item>
			<Group.Item grow={1}>
				<Stack itemsSpacing={2}>
					<Text size='bodySmall' color='primary'>
						{primaryLabel}
					</Text>
					{secondaryLabel && (
						<Text size='footnote' color='secondary'>
							{secondaryLabel}
						</Text>
					)}
					{tertiaryLabel && (
						<Text size='footnote' color='secondary'>
							{tertiaryLabel}
						</Text>
					)}
				</Stack>
			</Group.Item>
			{rightAccessory && <Group.Item>{rightAccessory}</Group.Item>}
		</Group>
	);
};
